import gql from 'graphql-tag';

export class FormInput {
  id: number;
  name: string;
  isActive: boolean;

  constructor() {
    this.id = undefined;
    this.name = undefined;
    this.isActive = undefined;
  }
}

export const gqlGetQuery = gql`
  query getCpWasteCategories($limit: Int, $offset: Int, $order: String, $where: String) {
    getCpWasteCategories(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        name
        firstDate
        firstUser
        isActive
        lastDate
        lastUser
      }
      recordCount
    }
  }
`;

export const gqlGetByIdQuery = gql`
  query getCpWasteCategoryById($id: Int) {
    getCpWasteCategoryById(id: $id) {
      id
      name
      firstDate
      firstUser
      isActive
      lastDate
      lastUser
    }
  }
`;

export const gqlAdd = gql`
  mutation addCpWasteCategory($data: CpWasteCategoryInput) {
    addCpWasteCategory(data: $data) {
      id
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateCpWasteCategory($data: CpWasteCategoryInput) {
    updateCpWasteCategory(data: $data) {
      id
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteCpWasteCategory($id: Int) {
    deleteCpWasteCategory(id: $id)
  }
`;
